import session from '@cognitoforms/api/services/session';

export default [
	{
		path: '/organization/new', component: ()=> import('src/views/settings/LegacyCreateOrganization.vue'),
		name: 'new-organization',
		props: true,
		meta: {
			isRouterLink: true,
			auth: 'required'
		},
		async beforeEnter(to, from, next) {
			if (session.value && session.value.enabledFeatures.AppNav) {
				// Redirect to account settings organization section to create new organization.
				next({ path: '/myaccount', hash: '#organizations' });
			}
			else
				next();
		}
	}
];